<template>
    <v-card>
        <v-card-title>Alarm Filter Views</v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pt-4">
            <!-- <v-row v-for="(filter, index) in $props.filters" dense style="height: 70px;"> -->
            <v-simple-table height="400" fixed-header>
                <thead>
                    <tr>
                        <th class="text-left">Name</th>
                        <th class="text-left">Created By</th>
                        <th class="text-left">Compatible Filters</th>
                        <th class="text-left">Apply</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(view, index) in $props.views" :class="{disabled: !getCompatibleFilters(view).length}">
                        <td>{{view.view_name}}</td>
                        <td>{{usernameLookup(view.user_id)}}</td>
                        <td>{{getCompatibleFilters(view).length}}</td>
                        <td>
                            <v-btn color="#c42111" fab x-small @click="applyViewFilters(view)" :disabled="!getCompatibleFilters(view).length">
                                <v-icon>mdi-check</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="closeClick">Close</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'AlarmFilterViews',
    props: ['views', 'compatibleFilters'],
    components: {

    },
    data: () => ({
        
    }),

    computed: {
    },

    methods: {
        usernameLookup: function(userId) {
            for(let user of this.$store.state.batchConfig.users) {
                if(user.user_id == userId) {
                    return user.user_username;
                }
            }
            return '';
        },

        closeClick: function() {
            this.$emit('close');
        },

        applyViewFilters: function(view) {
            let compatibleFilterKeys = this.getCompatibleFilters(view);
            let compatibleFilterData = {};
            for(let key of compatibleFilterKeys) {
                compatibleFilterData[key] = JSON.parse(JSON.stringify(view.view_grid_config.filterData[key]));
            }
            this.$emit('import', compatibleFilterData);
        },

        getCompatibleFilters: function(view) {
            let compatibleFilterKeys = this.$props.compatibleFilters.map(cf => {return cf.value;});
            return Object.keys(view.view_grid_config.filterData).filter(k => {return compatibleFilterKeys.includes(k)});
        }
    },

    created() {
        console.log(this.$props.views);
    },

    mounted() {
        
    }

  
};
</script>

<style>

    tr.disabled {
        color: rgb(110, 110, 110);;
    }

</style>
